import FFLoginController from 'FF/Controllers/User/LoginController';
import Terms from 'Vue/Web/Common/Terms.vue';

global.Controller = new class extends FFLoginController {
    Terms ?: Vue;
    ready() {
        super.ready();
        this.Terms = new Vue({
            el: '.terms',
            components: {
                Terms,
            },
        });
    }
}
